import { render, staticRenderFns } from "./MainNavSmall.vue?vue&type=template&id=037ffaf6"
import script from "./MainNavSmall.vue?vue&type=script&lang=js"
export * from "./MainNavSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports